import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { IBidValidityConfigurationQueryParams } from '../types';

/**
 * React Query state key for fetch BID VALIDITY CONFIGURATION api.
 */
const FETCH_BID_VALIDITY_CONFIGURATION_QUERY_KEY =
  'fetch-bid-validity-configuration-query-key';

/**
 * React Query hook for bid validity configuration api management.
 */
export const useBidValidityConfigurationQuery = (
  params: IBidValidityConfigurationQueryParams
) => {
  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      queryKey: [FETCH_BID_VALIDITY_CONFIGURATION_QUERY_KEY, params],
      queryFn: () => BIDS_API.fetchBidValidityConfiguration(params),
      retry: false,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    refetch,
  };
};
